module.exports = __webpack_public_path__ + "static/media/crmnew.e34ea101.png";